"use client";
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import { ErrorBoundary } from "react-error-boundary";




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App></App>
    </ErrorBoundary>


  </React.StrictMode>
);

